import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StateService {

    private _state = signal<{ [key: string]: any }>({});

    get state() {
        return this._state;
    }

    setState(key: string, value: any) {
        const currentState = this._state();
        this._state.set({ ...currentState, [key]: value });
    }

    removeState(key: string) {
        const currentState = this._state();
        if (key in currentState) {
            const { [key]: _, ...newState } = currentState;
            this._state.set(newState);
        }
    }

    resetState() {
        this._state.set({});
    }
}
